<template>
    <div>
        <div class="container">
            <!-- Semester classes section -->
            <div v-if="regularCourses.length > 0" class="row px-3" :class="{ 'justify-content-center': regularCourses.length === 1 }">
                <div class="col-12">
                    <div class="text-center fs-1 pt-5 pb-4 text-uppercase oswald-bold">
                        Spring Classes
                    </div>
                </div>
                <div v-for="(course, index) in regularCourses" :key="course.id"
                    class="col-md-4 d-flex flex-column align-items-center justify-content-start pb-3 px-3 class-card"
                    :style="{ cursor: 'pointer', transitionDelay: `${index * 0.12}s` }"
                    @click="goToCourse(course.link)">

                    <!-- <img :src="`${$API_ASSETS}${course.banner_image.id}?width=800&quality=80`" class="img-fluid py-2" />   -->
                    <div class="position-relative">
                        <img v-if="course.banner_image && course.banner_image.id"
                            :src="`${$API_ASSETS}${course.banner_image.id}?width=800&quality=80`" class="img-fluid py-2" />
                        <img v-if="course.core_req" :src="require('@/assets/CoreRequired.png')" class="position-absolute"
                            :style="{ bottom: '-15%', width: '25%', transform: course.is_free ? 'translate(-200%,0%)' : 'translate(-100%,0%)' }" />
                        <img v-if="course.is_free" :src="require('@/assets/free.png')" class="position-absolute"
                            style="bottom: -15%; width: 25%; transform: translate(-100%,0%);" />
                    </div>

                    <div class="text-start py-2 text-overlay" style="position: relative; z-index: 3;">
                        <span class="fs-3 text-uppercase oswald-bold pt-1">{{ course.name }}</span>
                        <div class="h5 oswald-bold pt-1">{{ course.meets_text }}</div>
                        <!-- <div class="oswald-bold pt-1" v-if="course.core_req">NOTE: Enrollment is only open to those who
                            have completed our Core
                            class.</div> -->
                        <div class="m-0 py-2">{{ course.long_desc || '' }}</div>

                        <!-- <div class="m-0 py-2">{{ course.logistics_text || '' }}</div> -->

                    </div>
                    <div class="w-100 text-start">
                        <a :href="`${course.link}`" class="cardlink text-uppercase pb-5"> Register
                            <i class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div></div>
            </div>

            <!-- Workshops Section -->
            <div v-if="workshopCourses.length > 0" class="row px-3" :class="{ 'justify-content-center': workshopCourses.length === 1 }">
                <div class="col-12">
                    <div class="text-center fs-1 pt-5 pb-4 text-uppercase oswald-bold">
                        Workshops
                    </div>
                </div>
                <div v-for="(course, index) in workshopCourses" :key="course.id"
                    class="col-md-4 d-flex flex-column align-items-center justify-content-start pb-3 px-3 class-card"
                    :style="{ cursor: 'pointer', transitionDelay: `${index * 0.12}s` }"
                    @click="goToCourse(course.link)">

                    <!-- <img :src="`${$API_ASSETS}${course.banner_image.id}?width=800&quality=80`" class="img-fluid py-2" />   -->
                    <div class="position-relative">
                        <img v-if="course.banner_image && course.banner_image.id"
                            :src="`${$API_ASSETS}${course.banner_image.id}?width=800&quality=80`" class="img-fluid py-2" />
                        <img v-if="course.core_req" :src="require('@/assets/CoreRequired.png')" class="position-absolute"
                            :style="{ bottom: '-15%', width: '25%', transform: course.is_free ? 'translate(-200%,0%)' : 'translate(-100%,0%)' }" />
                        <img v-if="course.is_free" :src="require('@/assets/free.png')" class="position-absolute"
                            style="bottom: -15%; width: 25%; transform: translate(-100%,0%);" />
                    </div>

                    <div class="text-start py-2 text-overlay" style="position: relative; z-index: 3;">
                        <span class="fs-3 text-uppercase oswald-bold pt-1">{{ course.name }}</span>
                        <div class="h5 oswald-bold pt-1">{{ course.meets_text }}</div>
                        <!-- <div class="oswald-bold pt-1" v-if="course.core_req">NOTE: Enrollment is only open to those who
                            have completed our Core
                            class.</div> -->
                        <div class="m-0 py-2">{{ course.long_desc || '' }}</div>

                        <!-- <div class="m-0 py-2">{{ course.logistics_text || '' }}</div> -->

                    </div>
                    <div class="w-100 text-start">
                        <a :href="`${course.link}`" class="cardlink text-uppercase pb-5"> Register
                            <i class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div></div>
            </div>
            <!-- Previous Workshops Section -->
            <div v-if="previousWorkshops.length > 0" class="row px-3 pb-5">
                <div class="col-12">
                    <div class="text-center fs-1 pt-5 pb-4 text-uppercase oswald-bold"
                        style="cursor: pointer;" @click="showPreviousWorkshops = !showPreviousWorkshops">
                        Previous Workshops
                        <i :class="showPreviousWorkshops ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"
                            style="font-size: 1.5rem; margin-left: 0.5rem; vertical-align: middle;"></i>
                    </div>
                </div>
                <transition name="prev-workshops">
                    <div v-if="showPreviousWorkshops" class="row w-100 px-0 mx-0"
                        :class="{ 'justify-content-center': previousWorkshops.length === 1 }">
                        <div v-for="course in previousWorkshops" :key="course.id"
                            class="col-md-4 d-flex flex-column align-items-center justify-content-start pb-3 px-3"
                            @click="goToCourse(course.link)" style="cursor: pointer; text-decoration: none;">

                            <div class="position-relative">
                                <img v-if="course.banner_image && course.banner_image.id"
                                    :src="`${$API_ASSETS}${course.banner_image.id}?width=800&quality=80`" class="img-fluid py-2" />
                                <img v-if="course.core_req" :src="require('@/assets/CoreRequired.png')" class="position-absolute"
                                    style="bottom: -15%; width: 25%; transform: translate(-120%,0%);" />
                                <img v-if="course.is_free" :src="require('@/assets/free.png')" class="position-absolute"
                                    style="bottom: -15%; width: 25%; transform: translate(-100%,0%);" />
                            </div>

                            <div class="text-start py-2 text-overlay" style="position: relative; z-index: 3;">
                                <span class="fs-3 text-uppercase oswald-bold pt-1">{{ course.name }}</span>
                                <div class="h5 oswald-bold pt-1">{{ course.meets_text }}</div>
                                <div class="m-0 py-2">{{ course.long_desc || '' }}</div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>

        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'AllClasses',
    data() {
        return {
            classesData: [],
            semesterData: [],
            sectionData: [],
            showPreviousWorkshops: false,
        };
    },
    computed: {
        regularCourses() {
            if (!this.classesData) return [];
            return this.classesData.filter(course => course.is_workshop !== true && !course.is_previous_workshop);
        },
        workshopCourses() {
            if (!this.classesData) return [];
            return this.classesData.filter(course => course.is_workshop === true && !course.is_previous_workshop);
        },
        previousWorkshops() {
            if (!this.classesData) return [];
            return this.classesData.filter(course => course.is_previous_workshop === true);
        }
    },
    methods: {
        goToCourse(link) {
            window.location.href = `${link}`;
        },
        async fetchClassData() {
            try {
                const response = await axios.post(this.$API_GRAPHQL, {
                    query: `
                      query {
                    courses: class(
                        filter: { status: { _eq: "published" } }
                        sort: ["display_order"]
                    ) {
                        id
                        name
                        description
                        meets_text
                        logistics_text
                        link
                        display_order
                        core_req
                        is_free
                        is_workshop
                        is_previous_workshop
                        long_desc
                        banner_image {
                            id
                        }
                        session_id{
                            start_dt
                        }
                    }
                    semester:semester_details{
                        id
                        number_of_sessions
                        sale_dt
                        start_date
                        banner_title
                    }
            courseSection: class_session {
                id
                start_dt
                course:class_id{
                    id
                    name
                }
            }


            }

                    `
                }, {
                    headers: {
                        'Authorization': `Bearer Pm4Nd5_e46HaK2xtkPcla2PMBzbk9AQf`,
                        'Content-Type': 'application/json'
                    }
                });

                this.classesData = response.data.data.courses || [];
                this.semesterData = response.data.data.semester || [];
                this.sectionData = (response.data.data.courseSection || []).sort((a, b) => new Date(a.start_dt) - new Date(b.start_dt));
                console.log('Fetched Class Data:', this.classesData);
            } catch (error) {
                console.error('Error fetching class data:', error);
            }
        },
        getDayOfWeek(start_dt) {
            const date = new Date(start_dt);
            return date.toLocaleDateString('en-US', { weekday: 'long' });
        },
        format12HourTime(isoString) {
            const date = new Date(isoString);
            let hours = date.getHours() % 12 || 12; // Convert 24-hour to 12-hour format, ensuring 12 is correctly represented
            // let period = date.getHours() >= 12 ? 'PM' : 'AM';
            let intHours = parseInt(hours);
            let endHours = intHours + 2;

            return `${intHours} - ${endHours} pm`; // Format as "3PM"
        },
        formatMonthDay(isoString) {
            const date = new Date(isoString);
            return `${date.getMonth() + 1}/${date.getDate()}`; // getMonth() is zero-based, so add 1
        },
        observeCards() {
            if (this._cardObserver) this._cardObserver.disconnect();
            const cards = this.$el.querySelectorAll('.class-card');
            this._cardObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('class-card--visible');
                        this._cardObserver.unobserve(entry.target);
                    }
                });
            }, { threshold: 0.1 });
            cards.forEach(card => this._cardObserver.observe(card));
        }
    },
    created() {
        this.fetchClassData();
    },
    mounted() {
        this.observeCards();
    },
    updated() {
        this.$nextTick(() => this.observeCards());
    },
    beforeUnmount() {
        if (this._cardObserver) this._cardObserver.disconnect();
    }
};
</script>

<style scoped>
.text-overlay {
    position: relative;
    z-index: 2;
}

.class-card {
    opacity: 0;
    transform: translateY(28px);
    transition: opacity 0.5s ease, transform 0.5s ease;
}

.class-card--visible {
    opacity: 1;
    transform: translateY(0);
}

.prev-workshops-enter-active {
    transition: max-height 0.45s ease, opacity 0.45s ease;
    overflow: hidden;
    max-height: 5000px;
}
.prev-workshops-leave-active {
    transition: max-height 0.35s ease, opacity 0.35s ease;
    overflow: hidden;
    max-height: 5000px;
}
.prev-workshops-enter-from,
.prev-workshops-leave-to {
    max-height: 0;
    opacity: 0;
}
</style>
